export default __webpack_public_path__ + "static/media/green4.f09075b7.png";